import { v4 as uuidv4 } from "uuid";
export class ProductsModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.description = "";
        this.owner = "";
        this.startedYear = "";
        this.domain = "";
    }
}
export default class Products extends ProductsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
